export default function App() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-bg px-6">
      <div className="w-full max-w-md rounded-lg border border-border bg-surface p-8 shadow-sm">
        <h1 className="font-display text-3xl font-semibold text-primary">SupplySage Web App</h1>
        <p className="mt-2 text-sm text-text-muted">Admin and coordinator command interface.</p>
        <button
          type="button"
          disabled
          className="mt-8 w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60"
        >
          Sign in
        </button>
        <p className="mt-3 text-center text-xs text-text-muted">Magic link auth lands in P2.</p>
      </div>
    </main>
  );
}
